import UserViewsTable from './UserViewsTable';
export default UserViewsTable;